<Modal
  title="Are you sure?"
  {isLoading}
  on:close={() => ($uiState.activeModal = undefined)}
  on:action={() => apply()}>
  Are you sure?

  {#if errorMessage}
    <div class="notification is-danger is-light">{errorMessage}</div>
  {/if}
</Modal>

<script lang="ts">
  export let item : Offer_v2_Doc;

  import { logging } from '../../../../lib/logging';
  import { uiState } from "../../../../lib/uiState";
  import Modal from "../../../_components/Modal.svelte";

  let errorMessage : string;
  let isLoading = false;

  async function apply() {
    let firebase = window.firebase;

    isLoading = true;

    await firebase
      .functions()
      .httpsCallable('api-offer-approveoffer')({ id: item.id } as ApproveOfferParams)
      .catch((err) => {
        logging.report(err.toString());
        errorMessage = err;
      })
      .finally(() => (isLoading = false));

    $uiState.activeModal = undefined;
    
  }
</script>
